import { PayItemsOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/header'
import { useDesignSubmittalLogContext } from '../../../DesignSubmittalLogContext'
import { DesignSubmittal } from '../../../DesignSubmittalLogContext/types'

export function usePayItemsOptions(): PayItemsOptions<DesignSubmittal> {
  const { payItemGlobalId } = useDesignSubmittalLogContext()
  return {
    hidden: !!payItemGlobalId,
    globalId: payItemGlobalId,
    onFilter: (value, { dsToPayItemNoGeometries }) =>
      dsToPayItemNoGeometries.some(
        ({ payItem: { globalId } }) => value === globalId
      ),
  }
}
